'use strict';
; (function () {
    var patientInventoryExpiredMedsReportModuleRoutes = [

        {
            //"state": true,
            "name": "Inhouse_Expired_Medications_Details_Popup",
            //"url": "OrderableDrugsDrugStrengthFormwithRXNormCodesMasterTable",
            "RoutingNumber": 2939,
            "settignId" : 475,
            templateUrl: "<div emr-rx-inhouse-expired-medications-details-popup></div>",
            files: [
                "AngularScripts/PatientInventoryExpiredMedicationsReport/Directives/RxInHouseExpiredMedicationsDetailsPopupDirective.js",
                "AngularScripts/PatientInventoryExpiredMedicationsReport/Services/PatientInventoryExpiredMedsService.js"
            ]
        },

    ];

    angular.module('EMR.PatientInventoryExpiredMedsReportModule' , [])
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(patientInventoryExpiredMedsReportModuleRoutes, $stateProvider);
            }]);
})();
